const getSearchParams = (url) => {
  const searchParams = [
    'adgroupname',
    'campaignname',
    'device',
    'gclid',
    'internal_user',
    'keyword',
    'landing_page',
    'my_link',
    'referrer',
    'utm_ad_title',
    'utm_adgroup',
    'utm_campaign',
    'utm_source',
    'utm_origin',
  ];

  const urlParams = new URLSearchParams(url);

  return searchParams.reduce((params, key) => {
    if (urlParams.has(key)) {
      if (key === 'adgroupname') {
        params['utm_adgroup'] = urlParams.get(key);
      } else if (key === 'campaignname') {
        params['utm_campaign'] = urlParams.get(key);
      } else {
        params[key] = urlParams.get(key);
      }
    }

    return params;
  }, {});
};

export const handleGetYourQuoteClick = (language) => {
  const queryParams = new URLSearchParams({
    slide: 'building_type',
    landing_page: `${window.location.origin}${window.location.pathname}`,
    referrer: sessionStorage.getItem('referrer') || '',
    ...getSearchParams(sessionStorage.getItem('search')),
  });

  const leadGenFormUrl = new URL(process.env.GATSBY_LEAD_GEN_FORM_URL);
  leadGenFormUrl.pathname = `${language}/flow`;
  leadGenFormUrl.search = queryParams.toString();

  window?.open(leadGenFormUrl.toString(), '_blank');
};
